import { createFileRoute } from "@tanstack/react-router";
import { CATEGORY_PILLARS } from "@/data/category-pillars";
import { CategoryPillarPage, categoryPillarJsonLd } from "@/components/CategoryPillarPage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const pillar = CATEGORY_PILLARS.interpreter;

export const Route = createFileRoute("/interpreter/")({
  head: () => {
    const url = `${SEO_SITE}/interpreter`;
    return {
      meta: [
        { title: ctaTitle(pillar.metaTitle, "/interpreter", "th")},
        { name: "description", content: ctaDesc(pillar.metaDesc, "/interpreter", "th")},
        { property: "og:title", content: ctaTitle(pillar.metaTitle, "/interpreter", "th")},
        { property: "og:description", content: ctaDesc(pillar.metaDesc, "/interpreter", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/interpreter")],
      scripts: categoryPillarJsonLd(pillar, url),
    };
  },
  component: () => <CategoryPillarPage pillar={pillar} />,
});
